import { render, staticRenderFns } from "./resInfo.vue?vue&type=template&id=75d29090&scoped=true&"
import script from "./resInfo.vue?vue&type=script&lang=js&"
export * from "./resInfo.vue?vue&type=script&lang=js&"
import style0 from "./resInfo.vue?vue&type=style&index=0&id=75d29090&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d29090",
  null
  
)

export default component.exports